// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import DashboardGoogleChartGraphics from '../../components/Dashboard/DashboardGoogleChartGraphics';
import WidgetDetail from '../../components/Dashboard/WidgetDetail';
import DevicesOperationMenu from '../../components/Dashboard/DevicesOperationMenu';
import avatarHelias from '../../img/dark-theme/helias-avatar.png'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const lastDashboardDataRequestURL = endpointHelias+'/Helias/V0/General/lastDashboardData'
const lastSmartDevicesStatusRequestURL = endpointHelias+'/Helias/V0/General/lastSmartDevicesStatus'
const postCollectInstallationAnalytics = endpointHelias+'/Helias/V0/Analytics/postCollectInstallationAnalytics';	

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");
var generalCommonJS = require("../../js/generalCommon.js");
var stripeCommonJS = require("../../js/stripeCommon.js")

var objDayForecasting = []
var municipalityId = ""

// DASHBOARD

const Dashboard = (params) => {

  useEffect(() => {   

    document.title = "HELIAS - Inicio"     

    localStorage.removeItem("lastDashboardData")          
    localStorage.removeItem("lastSmartDevicesStatus")          

    stripeCommonJS.verificarSuscripcion(cargaTotalInicialDashboard)

    generalCommonJS.autocierrePrivacidadGoogle()

    return () => {// Anything in here is fired on component unmount.
      try{
        document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" hidden","") + " hidden"
      }
      catch(error){console.log(error)}
      clearInterval(downloadTimer)            
      clearTimeout(nextDashboardLoadTimeout)      
    }

  }, [params.update]);

  var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
  var fechaActual = (new Date(Date.now() - tzoffset)).toISOString()

  const [objHorarioSol, setObjHorarioSol] = useState({"Sunrise": "","Sunset": ""})
  const [objListadoDispositivos, setObjListadoDispositivos] = useState([])  
  const [graphsData, setObjGraphsData] = useState([
    {"DATETIME":fechaActual.substring(0,19),"TotalBulkConsumption":"0"}    
  ])    
  const [graphUpdateTimestamp, setObjGraphUpdateTimestamp] = useState(0)
  const [devicesUpdateTimestamp, setObjDevicesUpdateTimestamp] = useState(0)
  const [weekForecastUpdateTimestamp, setObjWeekForecastUpdateTimestamp] = useState(0)
    
  var nextDashboardLoadTimeout = ""
  var downloadTimer = ""

  function cargaTotalInicialDashboard(){

    cargarDatosInitialHelp()
    localStorage.removeItem("dashboardInitialLoad")
    localStorage.removeItem("forceUpdate")
    localStorage.removeItem("currentInstallationConfiguration")
    document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" hidden","")
    document.getElementById("iconoRefrescoDashboard").addEventListener("click", () => recargarDashboard("full"));    
    cargarDashboard()    

  }

  function cargarDatosInitialHelp(){
    
    if(localStorage.getItem("showInitialHelp") !== null){
      document.getElementById("initialHelp").className = document.getElementById("initialHelp").className.replaceAll(" hidden", "")
      document.getElementById("saludoInitialHelp").innerHTML ="Hola, "+generalCommonJS.obtenerNombreUsuario()
      document.getElementById("barraProgresoInitialHelp").style = "--indicator-progress: 84%;"
      localStorage.removeItem("showInitialHelp")
    }    

  }

  function recargarDashboard(tipoRefresh){  
    
    document.getElementById("iconoRefrescoDashboard").className = document.getElementById("iconoRefrescoDashboard").className.replaceAll(" updating", "") + " updating"    
    document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" loading", "") + " loading"    

    if(tipoRefresh === "full"){
      localStorage.setItem("forceUpdate", "true") 
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'CUADRO DE MANDO - Refresco manual', "", "")
    }
    clearInterval(downloadTimer)      
    clearTimeout(nextDashboardLoadTimeout)          
    cargarDashboard()        
  }

  function cargarDashboard(){   

    try{
      if(document.getElementById("mainDashboard") !== null){

        var actualizarDashboard = true

        if(actualizarDashboard){

          if(localStorage.getItem("dashboardInitialLoad") === null){
            document.getElementById("loaderGeneralAplicacion").className = "loader overlay"
            document.getElementById("loaderMenuDispositivos").className = "loader overlay"
          }

          var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
          var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
          //Petición de datos para el paso actual
          var jsonPeticion = {
            "accountID": localStorage.getItem("accountID"),
            "installationID": localStorage.getItem("installationId") 
          }

          if( (localStorage.getItem("forceUpdate") !== null) ){
            jsonPeticion = {
              "accountID": localStorage.getItem("accountID"),
              "installationID": localStorage.getItem("installationId"), 
              "forceUpdate": "true" 
            }
          }           

          // Guardo la información  
          var xhttp = new XMLHttpRequest();  
            xhttp.open("POST", lastDashboardDataRequestURL, true);        
            xhttp.setRequestHeader('Content-Type', "application/json");
            xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
            var data = JSON.stringify(jsonPeticion);
            xhttp.onreadystatechange = function() {
              if (this.readyState === 4 && this.status === 200) {
                var jsonRespuesta = JSON.parse(this.responseText)
        
                if(jsonRespuesta.statusCode === "403"){                   
                  initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
                }
                else if(jsonRespuesta.statusCode === "500"){                
                  document.getElementById("errorInstallationSelectionButton").className = document.getElementById("errorInstallationSelectionButton").className.replaceAll(" hidden", "")
                  var mensaje = "Se produjo un error en la carga de información básica, revise que todos sus dispositivos funcionan correctamente y están correctamente conectados a internet. Causante/s del problema: "+jsonRespuesta.responseMessage

                  initialConfigCommonJS.mostrarErrorGeneral("report","ERROR",mensaje)      
                }
                else{          
                  //Si recibo datos ya configurados lo cargo  
                  try{
                    if(typeof jsonRespuesta.body !== 'undefined'){

                        console.log(jsonRespuesta)              
                        
                        if(localStorage.getItem("dashboardInitialLoad") === null){
                          document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
                        }

                        localStorage.setItem("dashboardInitialLoad", "true")
                        
                        
                        if(parseInt(jsonRespuesta.body.InstallationData.GeneralInfo.RulesConfigured) > 0){
                          dashboardCommonJS.precalentarLambda("postListInstallationRules")      
                        }                      

                        cargarDatosGraficas() 

                        localStorage.setItem("lastDashboardData", JSON.stringify(jsonRespuesta.body))                               
                        
                        //CARGO LOS DISPOSITIVOS INTELIGENTES EN PARALELO
                        cargarDispositivosInteligentes(jsonRespuesta.body)

                        //WIDGET METEO
                        dashboardCommonJS.cargarWidgetMeteo(jsonRespuesta.body.MeteoData,setObjHorarioSol,objDayForecasting)       
                        municipalityId = jsonRespuesta.body.MeteoData.MunicipalityId 
                        
                        //WIDGET INSTALACIÓN
                        dashboardCommonJS.cargarWidgetInstalacion(jsonRespuesta.body, "")

                        //WIDGET FV
                        if(Object.keys(jsonRespuesta.body.FVData).length > 0){                  
                          dashboardCommonJS.cargarWidgetFV(jsonRespuesta.body.InstallationData, jsonRespuesta.body.FVData)
                          document.getElementById("widgetFV").className = document.getElementById("widgetFV").className.replace(" hidden", "")
                        }

                        //WIDGET BATERÍAS
                        if(Object.keys(jsonRespuesta.body.BatteriesData).length > 0){              
                          dashboardCommonJS.cargarWidgetBaterias(jsonRespuesta.body.BatteriesData)
                          document.getElementById("widgetBaterias").className = document.getElementById("widgetBaterias").className.replace(" hidden", "")
                        }

                        //WIDGET GRUPO ELECTRÓGENO
                        if(Object.keys(jsonRespuesta.body.GeneratorData).length > 0){                            
                          dashboardCommonJS.cargarWidgetGrupoElectrogeno(jsonRespuesta.body.GeneratorData)
                          document.getElementById("widgetGrupoElectrogeno").className = document.getElementById("widgetGrupoElectrogeno").className.replace(" hidden", "")
                        }              
                        
                        //WIDGET COCHE        
                        if(Object.keys(jsonRespuesta.body.CarsData).length > 0){                                                                    
                          dashboardCommonJS.cargarWidgetCoche(jsonRespuesta.body.CarsData)                          
                          document.getElementById("widgetCoche").className = document.getElementById("widgetCoche").className.replace(" hidden", "")
                        }
                        
                        //Cargo el scoring de eficiencia/ahorro de la instalación
                        if( document.getElementById("detalleAUTOCONSUMO_AHORRO") !== null){                      
                          dashboardCommonJS.cargarScoring(jsonRespuesta.body, "")                      
                        }                              

                        //Actualización automática del dashboard
                        var fechaHoraConsultaDashboard = jsonRespuesta.body.MeteoData.QueryUpdateTime
                        var contadorRefresco = parseInt(jsonRespuesta.body.GeneralData.DashboardTimerRefresh.Value)
                        var timeStampDashboard = new Date(fechaHoraConsultaDashboard.replaceAll("/","-").replace(" - ", "T")).getTime();
                        var timeStampActual = Date.now()		
                        var tiempoDesdeUltimaActualizacion = parseInt((((timeStampActual - timeStampDashboard))/1000).toString())
                        var tiempoRestante = parseInt(contadorRefresco) - parseInt(tiempoDesdeUltimaActualizacion)
                    
                        if (tiempoRestante < 0){
                          tiempoRestante = contadorRefresco
                        }
                    
                        nextDashboardLoadTimeout = setTimeout(() => recargarDashboard("light"),((tiempoRestante)*1000));	
                        tiempoDesdeUltimaActualizacion = tiempoDesdeUltimaActualizacion - contadorRefresco
                        if(parseInt(tiempoDesdeUltimaActualizacion) < 0 ){
                          tiempoDesdeUltimaActualizacion = tiempoDesdeUltimaActualizacion * -1
                        }
                        
                        if(document.getElementById("labelTiempoUltimaActualizacion") !== null){
                          document.getElementById("labelTiempoUltimaActualizacion").innerHTML = ( tiempoDesdeUltimaActualizacion ).toString()+" Seg"              
                        }
                                        
                        downloadTimer = setInterval(function(){				
                          --tiempoRestante
                          ++ tiempoDesdeUltimaActualizacion		
                          if(document.getElementById("labelTiempoUltimaActualizacion") !== null){
                            document.getElementById("labelTiempoUltimaActualizacion").innerHTML = tiempoDesdeUltimaActualizacion.toString()+" Seg"                            
                          }
                          
                          if(tiempoRestante <= 0){				
                            clearInterval(downloadTimer);				
                          }
                        },1000);

                    }  

                    //Si no hay datos configurados entonces no hago nada
                  }
                  catch(error){console.log(error)}

                  console.log("Datos del dashboard cargados correctamente.")
                }
              }
        
              if (this.readyState === 4 && this.status !== 200) {      
                initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
              }
            }
            xhttp.send(data);   
        }  
      }
      else{
        console.log("Ya no estoy en el dashboard cancelo la carga.")
      }
    }
    catch(error){
      try{
        document.getElementById("iconoRefrescoDashboard").className = document.getElementById("iconoRefrescoDashboard").className.replaceAll(" updating", "")
        document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" loading", "")
      }
      catch(error2){}
      console.log("Controlo error de carga dashboard")
    }
  }

  function cargarDispositivosInteligentes(jsonObjRespuestaDashboard){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    //Petición de datos para el paso actual    

    var datosStripe = {}                      
    if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
      datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
    } 
    
    var idPlan = ""    
    try{ idPlan = datosStripe.priceId }
    catch(error){console.log(error)}

    var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "planId": idPlan }        

    if(localStorage.getItem("forceUpdate") !== null){
      jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "forceUpdate": "true", "planId": idPlan }
    } 

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", lastSmartDevicesStatusRequestURL, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {

          var jsonRespuesta = {}
          
          try{
            jsonRespuesta = JSON.parse(this.responseText)
          }
          catch(error){
            jsonRespuesta = {
              "statusCode": "204",
              "responseMessage": "Dispositivos actualizados correctamente",
              "body": []
            }
          }          
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  

            if(typeof jsonRespuesta.body !== 'undefined'){
              
              console.log(jsonRespuesta)     

              try{
                document.getElementById("loaderMenuDispositivos").className = "loader hidden"
              }
              catch(error){console.log(error)}       

              var dispositivosNoMedidoresConsumo = 0

              if(parseInt(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.RulesConfigured) === 0){              
                if(localStorage.getItem("lastSmartDevicesStatus") === null){
                  recargarDashboard("full")              
                }
              }   
                            
              if(jsonRespuesta.body.length > 0){

                  localStorage.setItem("lastSmartDevicesStatus", JSON.stringify(jsonRespuesta.body))  

                  //CARGA DETALLE
                  var listadofinalDispositivosInteligentes = []
                                    
                  for(var x=0; x < jsonRespuesta.body.length; x++){
                    
                    listadofinalDispositivosInteligentes.push(jsonRespuesta.body[x])
                    
                    //Miro cuantos dispositivos NO son medidores de consumo
                    if(jsonRespuesta.body[x].TipoDispositivo !== "MONITOR_CONSUMO"){
                      dispositivosNoMedidoresConsumo = dispositivosNoMedidoresConsumo + 1
                    }                    

                  }
                  
                  //CARGA INFORMACIÓN BÁSICA
                  var numeroDispositivosConfigurados = listadofinalDispositivosInteligentes.length

                  if(document.getElementById("numeroDispositivosDetalle") !== null){                    
                    if(numeroDispositivosConfigurados === 1){
                      document.getElementById("numeroDispositivosDetalle").innerHTML = numeroDispositivosConfigurados + " dispositivo"  
                    }
                    else{
                      document.getElementById("numeroDispositivosDetalle").innerHTML = numeroDispositivosConfigurados + " dispositivos"  
                    }
                    
                  }

                  setObjListadoDispositivos(listadofinalDispositivosInteligentes)   

              }
              else{//No hay dispositivos                

                if(document.getElementById("numeroDispositivosDetalle") !== null){
                  document.getElementById("numeroDispositivosDetalle").innerHTML = "Dispositivos"
                }                

                setObjListadoDispositivos([])            
                listadofinalDispositivosInteligentes = []
                localStorage.setItem("lastSmartDevicesStatus", JSON.stringify(listadofinalDispositivosInteligentes))      
              }

            }

            console.log("Dispositivos inteligentes cargados correctamente.")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }

        try{
          document.getElementById("iconoRefrescoDashboard").className = document.getElementById("iconoRefrescoDashboard").className.replaceAll(" updating", "")
          document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" loading", "")
        }
        catch(error){}

      }
      xhttp.send(data);
    
  }

  function cargarDatosGraficas(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    //Preparo la base de la fecha ya que las gráficas sólo mostrarán información del día en curso
    var fechaActual = new Date();
    var añoActual = fechaActual.getFullYear();
    var mesActual = (fechaActual.getMonth()+1);
    var diaActual = fechaActual.getDate();
      
    if (mesActual < 10){ mesActual = "0"+mesActual;	}
    if (diaActual < 10){ diaActual = "0"+diaActual;	}

    var datetimeDesde = añoActual+"-"+mesActual+"-"+diaActual + "T00:00:00"
    var datetimeHasta = añoActual+"-"+mesActual+"-"+diaActual + "T23:59:59"

    //Petición de datos para el paso actual    
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId"),
      "datetimeFrom": datetimeDesde,
      "datetimeTo": datetimeHasta,
      "filters": "FVMaxGenerationEstimation-GeneralWhFVGeneration-TotalMaximunGeneration-TotalBulkConsumption-TotalWastedEnergy-GeneralBatteryPercentage-ChargeLevel-GeneralWhGeneratorTOTALGeneration-GeneralWhGeneratorGenerationP1-GeneralWhGeneratorGenerationP2-GeneralWhGeneratorGenerationP3"
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postCollectInstallationAnalytics, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          
          //Si recibo datos ya configurados lo cargo  

          if(typeof jsonRespuesta.body !== 'undefined'){

            if(jsonRespuesta.body.length > 1){    

              setObjGraphsData(jsonRespuesta.body)
              
            }
              
            console.log("No se han recuperado datos de analítica.")
 
          }
          
          console.log(jsonRespuesta)

          try{
            document.getElementById("loaderdashboardGraficaGENERAL").className = document.getElementById("loaderdashboardGraficaGENERAL").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("loaderdashboardGraficaINSTALACION").className = document.getElementById("loaderdashboardGraficaINSTALACION").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("loaderdashboardGraficaFV").className = document.getElementById("loaderdashboardGraficaFV").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("loaderdashboardGraficaBATERIAS").className = document.getElementById("loaderdashboardGraficaBATERIAS").className.replaceAll(" hidden", "") + " hidden"              
            document.getElementById("loaderdashboardGraficaGRUPOELECTROGENO").className = document.getElementById("loaderdashboardGraficaGRUPOELECTROGENO").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("loaderdashboardGraficaCOCHE").className = document.getElementById("loaderdashboardGraficaCOCHE").className.replaceAll(" hidden", "") + " hidden"
          }
          catch(error){}

          console.log("Datos de la gráfica cargados correctamente.")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);     
        
  }
 
  function navegarDeepLinkBack(urlRelativa){
    localStorage.setItem("deepLinkBack","true")
    window.location=urlRelativa
  }
  
  function abrirOpcion(e, opcion){
    e.stopPropagation()

    if(opcion === "7Dias"){
      dashboardCommonJS.mostrarDetalleWidget("Prevision7Dias",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)
    }
    else{
      dashboardCommonJS.mostrarDetalleWidget("METEO",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)
    }
    
  }

  function verMaximoHistoricoEnGrafica(){
    var fechaMaximoHistorico = JSON.parse(localStorage.getItem("lastDashboardData")).SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Datetime.split("T")    
    localStorage.setItem("analyticsQueryRequest", "HistoricalMaximun|"+fechaMaximoHistorico[0])
    params.seleccionarOpcionMenu("opcionMenuHeliasAnalytics")
  }

  function obtenerDatosAMostrarGraficaGeneral(){
    
    var datosAMostrar = ""

    if(JSON.stringify(graphsData[0]).includes("GeneralWhFVGeneration") && JSON.stringify(graphsData[0]).includes("TotalBulkConsumption")){
      datosAMostrar = ["DATETIME","GeneralWhFVGeneration","TotalBulkConsumption"]
    }
    else{
      datosAMostrar = ["DATETIME","TotalBulkConsumption"]
    }

    return datosAMostrar
  }

  function mensajeConfimacionResetearMaximoHistorico(){

    var nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML

    generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'CUADRO DE MANDO - Resetear máximo histórico', "", "")

    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","REINICIAR CONSUMO MÁXIMO HISTÓRICO", "¿Estás seguro de que quieres reiniciar tu consumo máximo histórico para tu instalación <strong>"+nombreInstalacion+"</strong> ? También se reiniciará el contador de excesos de potencia. Sólo te recomendamos hacerlo si has hecho algún cambio significativo en tu instalación o si alguno de tus sensores ha tenido lecturas erróneas.", initialConfigCommonJS.reiniciarMaximoHistorico, initialConfigCommonJS.cerrarMensajeBorrado)          

    document.getElementById("errorReportingButton").innerHTML = "Reiniciar"    

  }

  function abrirDetalleEconomics(e){
    e.stopPropagation()
    dashboardCommonJS.mostrarDetalleWidget("AUTOCONSUMO_AHORRO|2",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)
  }

  function verDetalleWidgetEconomics(e,tipoLink,setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA){
    e.stopPropagation()
    dashboardCommonJS.mostrarDetalleWidget(tipoLink,setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)
  }

  function abrirChat(){
    document.getElementById("figureDetalleWidget").innerHTML = '<img id="iconoChatHelias" src="" alt="Chat" width="36"/>'
    document.getElementById("iconoChatHelias").src = avatarHelias
    
    dashboardCommonJS.mostrarDetalleWidget("CHAT",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)
  }

  return (    

    <main id="mainDashboard" info={graphUpdateTimestamp}>

        <div id="initialHelp" className="loader hidden">
          <section className="error-container">
            <img src={avatarHelias} alt="Helias" width="80"/>
            <div className="message huge">
              <h1 id="saludoInitialHelp" className="title"> </h1>
              <p>Antes de empezar sólo quería comentarte que casi todo lo que vas a ver en pantalla se puede pulsar.</p>
            </div>
            <div className="horizontal gap-04 center">
              <figure className="avatar size-l cyan"><span className="material-icon">euro</span></figure>
              <button className="link size-xs" style={{padding: "24px", borderRadius: "8px", background: "radial-gradient(var(--cyan-300-40), transparent 70%)", overflow: "visible"}}>Dispositivos</button>              
              <div className="main-value ellipsis-container">
                <div className="generators-list">
                  <figure className="avatar size-l percentage-indicator pink">
                    <span className="material-icon pink">battery_std</span>
                    <span id="barraProgresoInitialHelp" className="indicator high">84 %</span>
                  </figure>
                </div>              
              </div>
            </div>
            
            <div className="message huge">
              <p>Así que pulsa sin miedo y descúbre todo lo que puedo hacer por ti.</p>
            </div>

            <ul className="actions">
              <button className="button primary" onClick={() => document.getElementById("initialHelp").className = document.getElementById("initialHelp").className.replaceAll(" hidden", "") + " hidden"}>Entendido</button>
            </ul>
          </section>
        </div>

        <div className="wrapper wrapper vertical gap-03">

          <fieldset id="fieldsetRevisemosTuTarifa" className="vertical gap-02 cyan hidden">
            <button className="forward icon-wrapper" onClick={() => navegarDeepLinkBack("/Advisory/EnergyBilling")}>
              <figure className="avatar size-l green"><span className="material-icon">euro</span></figure>
              <div className="content">
                <h1 className="size-l">Comencemos por lo básico</h1>                    
              </div>
            </button>  
          </fieldset>

          <fieldset id="fieldsetConfiguraTuTarifaElectrica" className="vertical gap-02 cyan hidden">
            <button className="forward icon-wrapper" onClick={() => navegarDeepLinkBack("/InstallationConfiguration/GeneralInfo")}>
              <figure className="avatar size-l green"><span className="material-icon">euro</span></figure>
              <div className="content">
                <h1 className="size-l">Configura tu potencia / tarifa</h1>                    
              </div>
            </button>  
          </fieldset>

          <div className="meteo-economics columns col-lg-2 gap-03">

            <div id="divMeteo" className=" hidden">
              <section id="widgetMeteo" className="widget bubble">

                  <header className="title">
                    <h1 className="size-xs fill">Meteorología</h1>                          
                    <button id="botonDetalleMETEO" className="link size-xs ellipsis" onClick={ (e) => abrirOpcion(e, "Ahora")}>Más información</button>                                                    
                    <button id="botonPrevision7Dias" className="link size-xs ellipsis" onClick={ (e) => abrirOpcion(e, "7Dias")}>Previsión</button>                                                                  
                  </header>

                  <div id="contenidoWidgetMeteo" className="vertical gap-04">
                    <div className="main-data">
                      <div className="main-value">
                        <figure id="figureAvatarTiempo" className="avatar size-xl">
                          <img id="iconoTiempoDashboard" src="" alt="" onError={() => document.getElementById("iconoTiempoDashboard").src = "/img/unknownWeather.png"}/>                          
                        </figure>
                        <dl className="vertical gap-01">
                          <dt id="literalTiempo" className="size-s">...</dt>
                          <dd id="literalTemperatura" className="headline-02">...° C</dd>
                        </dl>
                      </div>
                        <dl className="vertical text-right gap-01">
                          <dt className="size-s hidden">Municipio</dt>
                          <dd id="nombreMunicipio" className="headline-03">...</dd>
                          <dd id="valorProvinceName" className="size-l">...</dd>
                        </dl>
                    </div>

                    <meter id="sunLightMeter" min="0" max="0" value="0" className="weather icon-wrapper" />
                    
                    <div htmlFor="sunLight" className="additional-data ellipsis-container ">
                      
                      <h1 className="size-s fill horizontal gap-04 vertical-center pointer" onClick={ (e) => abrirOpcion(e, "Ahora")}> 

                        <div className="horizontal gap-04 fill">
                          <div className="horizontal vertical-center gap-02">
                            <figure className="avatar size-s cyan" width="25%">
                              <span className="material-icon">water_drop</span>
                            </figure>
                            <span id="infoLluviaWebWidget" className="size-s lowercase"></span> 
                          </div>         
                          
                          <div className="horizontal vertical-center gap-02">
                          <figure className="avatar size-s cyan"> 
                            <span className="material-icon">air</span>
                          </figure>
                          <span id="infoVientoWebWidget" className="size-s lowercase"></span> 
                          </div>
                        </div>

                        <div className="horizontal gap-04 end">
                          <div className="horizontal vertical-center gap-02">
                          <figure className="avatar size-s day">
                            <span className="material-icon">wb_twilight</span>
                          </figure>
                          <span id="horaSalidaSol" className="size-s lowercase"></span> 
                          </div>
                          
                          <div className="horizontal vertical-center gap-02">
                          <figure className="avatar size-s night"> 
                            <span className="material-icon">nights_stay</span>
                          </figure>
                          <span id="horaPuestaSol" className="size-s lowercase"></span> 
                          </div>
                        </div>

                      </h1> 
                      
                    </div>
                  </div>

              </section>
            </div>

            <div>
              <section id="widgetEconomics" className="widget bubble widget-totales">

                <header className="title">
                  <h1 id="tituloWidgetEconomia" className="size-xs fill">Economía</h1>
                  <button id="botonTarifasDiarias" className="link size-xs ellipsis" onClick={(e) => dashboardCommonJS.mostrarDetalleWidget("TARIFAS",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>Tarifas hoy</button>                                    
                  <button className="link size-xs ellipsis" onClick={(e) => abrirDetalleEconomics(e)}>Ver más</button>                                    
                </header>

                <div id="widgetScoring" className="scoring fill" >

                  <div className="horizontal gap-04 fill start">
                          
                    <div className="main-value fill">
                      <figure id="figureAhorroGasto" className="avatar size-l" onClick={(e) => verDetalleWidgetEconomics(e,"AUTOCONSUMO_AHORRO|2",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}><span className="material-icon">euro</span></figure>
                      <dl className="vertical ellipsis-container">
                        <dt id="literalAhorroGasto" className="size-s">Gasto mes</dt>
                        <dd id="scoringInstalacionAhorro" className="headline-03">...</dd>
                      </dl>
                    </div>

                    <div id="widgetDashboardMonedero" className="main-value fill right hidden">
                      <figure id="figureMonederoBaterias" className="avatar size-l gold" onClick={(e) => verDetalleWidgetEconomics(e,"AUTOCONSUMO_AHORRO|2",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}><span id="iconoMonederoBaterias" className="material-icon gold">wallet</span></figure>
                      <dl className="vertical ellipsis-container">                                   
                        <dt id="literalMonederoBaterias" className="size-s">Monedero</dt>
                        <dd id="scoringMonederoBaterias" className="headline-03">...</dd>
                      </dl>
                    </div>

                    <div id="widgetConsumoEnergia" className="main-value fill right hidden">
                      <figure id="figureAutoconsumo" className="avatar size-l" onClick={(e) => verDetalleWidgetEconomics(e,"AUTOCONSUMO_AHORRO|1",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}><span id="iconoAutoconsumo" className="material-icon">compost</span></figure>
                      <dl className="vertical ellipsis-container">                                   
                        <dt id="literalAutoconsumo" className="size-s">...</dt>
                        <dd id="scoringInstalacionEficiencia" className="headline-03">...</dd>
                      </dl>
                    </div>

                  </div>

                  <div className="vertical gap-02">

                    <div className="horizontal gap-04 fill end">
                      <div className="main-value buy-price fill">
                        <dl className="vertical">
                          <dt id="literalTarifaCompra" className="size-s">Tarifa compra ahora</dt>
                          <dd id="valorCompraAhoraDashboard" className="headline-03"></dd>
                        </dl>
                      </div>
                      <div id="divValorVentaAhoraDashboard" className="main-value sale-price text-right fill ">
                        <dl className="vertical">
                          <dt id="literalTarifaVenta"className="size-s">Tarifa venta ahora</dt>
                          <dd id="valorVentaAhoraDashboard" className="headline-03"></dd>
                        </dl>
                      </div>
                    </div>
                  </div>

                  <a id="linkAhorroTarifasDashboard" href="/Advisory/FeesAnalyzer/Auto" className="message small success left hidden">
                    <div className="horizontal vertical-center">
                      <span id="iconoFuentesAlternativasEnergia" className="material-icon">query_stats</span>                              
                      <span id="literalAhorroTarifaDashboard" className="fill size-s"></span>
                      <span className="material-icon">navigate_next</span>
                    </div>
                  </a>

                  <dl id="lineaLinkAutoconsumo" className="horizontal self-consumption gap-02 fill hidden">
                    <dt  className="size-s">Autoconsumo mes:</dt>
                    <dd className="size-s horizontal gap-01">
                      <span id="valorlineaLinkAutoconsumo"></span>
                      <button className="link inline-link size-xs vertical-center" onClick={(e) => verDetalleWidgetEconomics(e,"AUTOCONSUMO_AHORRO|1",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                        <span className="material-icon flip-right">expand_circle_down</span>
                      </button>
                    </dd>
                  </dl>

                </div>
                
                

              </section>
            </div>            
          </div>

          <div id="divTOTALES" className=" hidden">

            <div id="divWidgetTOTALES" className="col-md">  

              <section id="widgetTOTALES" className="widget bubble widget-totales">

                  <header className="title">
                    <h1 className="size-xs fill ellipsis">Resumen</h1> 

                    <button className="link size-xs" onClick={() => dashboardCommonJS.operarMenuDispositivos("abrir", setObjDevicesUpdateTimestamp, ReactGA)}>Dispositivos</button>
                    <button className="link size-xs" onClick={() => params.seleccionarOpcionMenu("opcionMenuRules")}>Reglas</button>
                    <button className="link size-xs" onClick={() => dashboardCommonJS.mostrarDetalleWidget("ACTIVIDAD_INSTALACION",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>Actividad</button>
                  </header>

                  <section id="widgetMeteoMobile" className=" hidden">
                    <header className="title">    
                      <h1 className="size-l fill horizontal gap-02 vertical-center pointer" onClick={ (e) => abrirOpcion(e, "Ahora")}>                                
                        <figure className="avatar size-s">
                          <img id="iconoTiempoDashboardMobile" src="" alt="" onError={() => document.getElementById("iconoTiempoDashboardMobile").src = "/img/unknownWeather.png"}/>
                        </figure>
                        <span id="infoTemperaturaMobile" className="size-s lowercase"></span> 

                        <figure className="avatar size-s cyan">
                          <span className="material-icon">water_drop</span>
                        </figure>
                        <span id="infoLluviaMobile" className="size-s lowercase"></span> 

                        <figure className="avatar size-s cyan"> 
                          <span className="material-icon">air</span>
                        </figure>
                        <span id="infoVientoMobile" className="size-s lowercase"></span> 

                      </h1>
                      
                      <button id="botonPrevision7Dias" className="link size-xs ellipsis" onClick={ (e) => abrirOpcion(e, "7Dias")}>Previsión</button>                                                                    

                    </header>
                  </section>

                  <section> 
                    <div key="DivDashboardGraficaGENERAL" onClick={() => params.seleccionarOpcionMenu("opcionMenuHeliasAnalytics")} style={{minHeight:"50px", position: "relative"}}>
                      <DashboardGoogleChartGraphics key={"dashboardGraficaGENERAL"} graphicId={"dashboardGraficaGENERAL"} graphsData={graphsData} fromDatetime={"00:00"} toDatetime={"23:59"} valoresEnGrafica={obtenerDatosAMostrarGraficaGeneral()}/>                                            
                    </div>
                  </section>

                  <div className="overview">
                    
                    <div htmlFor="totalesInstalacion" className="additional-data ellipsis-container">                        
                      <dl className="vertical ellipsis-container">
                        <dt id="etiquetaPotenciaActual"className="size-s">Consumo ahora</dt>
                        <dd id="potenciaActual">... Wh</dd>
                      </dl>
                      <dl className="vertical text-right ellipsis-container">
                      <dt className="size-s">Máximo disponible</dt>
                          <dd id="potenciaTOTALDisponible">... Wh</dd>
                      </dl>
                    </div>

                    <meter id="resumenGeneralConsumoMeter" min="0" max="0" value="0" className="fill"></meter>

                    <dl className="horizontal ellipsis-container gap-02 vertical-center">                      
                      <dt id="etiquetaConsumoMaximoHistorico" className="size-s" >Consumo máximo histórico:</dt>
                      <dd className="horizontal gap-01">
                        <span id="consumoMaximoHistoricoTotal" className="size-s link" onClick={() => verMaximoHistoricoEnGrafica()}></span>                         
                        <span id="botonMaximoHistorico" className="size-s link material-icon red" onClick={() => mensajeConfimacionResetearMaximoHistorico()}>delete</span>                                                
                      </dd>
                    </dl>

                    <div id="contenedorBotoneraInferiorDashboard" className="main-data ellipsis-container">

                      <div id="divTomandoDeLaRed" className="main-value ellipsis-container hidden">                            
                        <dl className="vertical ellipsis-container">
                          <dt id="etiquetaTomandoDeLaRed" className="size-s"></dt>
                          <dd id="tomandoDeLaRed" >... Wh</dd>
                        </dl>
                        <div className="generators-list">
                          <figure id="figureTomandoDeLaRed" className="avatar green" onClick={() => dashboardCommonJS.mostrarDetalleWidget("INSTALACION",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span id="spanFigureTomandoDeLaRed" className="material-icon"></span>
                          </figure>
                        </div>
                      </div>

                      <div id="divGenerando" className="main-value ellipsis-container">                            
                        <dl className="vertical ellipsis-container">
                          <dt className="size-s">Generando</dt>
                          <dd id="generacionTOTALActual">... Wh</dd>
                        </dl>
                        <div className="generators-list">
                          <figure id="figureFVGenerando" className="avatar disabled hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("FV",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">solar_power</span>
                          </figure>
                          <figure id="figureBateriasGenerando" className="avatar disabled percentage-indicator hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("BATERIAS",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">battery_std</span>   
                            <span id="etiquetaPorcentajeBateriasGenerando" className="indicator"></span>
                          </figure>
                          <figure id="figureGrupoGenerando" className="avatar disabled percentage-indicator hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("GRUPOELECTROGENO",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">dynamic_form</span>
                            <span id="etiquetaPorcentajeGrupoGenerando" className="indicator"></span>
                          </figure>
                        </div>
                      </div>

                      <div id="divConsumiendo" className="main-value ellipsis-container">                            
                        <dl className="vertical ellipsis-container">
                          <dt className="size-s">Consumiendo</dt>
                          <dd id="consumoTOTALActual">... Wh</dd>
                        </dl>
                        <div className="generators-list">
                          <figure id="figureInstalacionConsumiendo" className="avatar disabled hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("INSTALACION",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">{dashboardCommonJS.obtenerIconoInstalacion(localStorage.getItem("installationName").split("*")[0])}</span>
                          </figure>
                          <figure id="figureBateriasConsumiendo" className="avatar disabled percentage-indicator hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("BATERIAS",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">battery_std</span>
                            <span id="etiquetaPorcentajeBateriasConsumiendo" className="indicator"></span>
                          </figure>
                          <figure id="figureCocheConsumiendo" className="avatar disabled percentage-indicator hidden" onClick={() => dashboardCommonJS.mostrarDetalleWidget("COCHE",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span className="material-icon">directions_car</span>
                            <span id="etiquetaPorcentajeCocheConsumiendo" className="indicator"></span>
                          </figure>                              
                        </div>
                      </div>

                      <div id="divDevolviendoARed" className="main-value ellipsis-container hidden">                            
                        <dl className="vertical ellipsis-container">
                          <dt id="etiquetaDevolviendoARed" className="size-s">...</dt>
                          <dd id="devolviendoARed">... Wh</dd>
                        </dl>
                        <div className="generators-list">
                          <figure id="figureDevolviendoARed" className="avatar green" onClick={() => dashboardCommonJS.mostrarDetalleWidget("INSTALACION",setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA)}>
                            <span id="spanFigureDevolviendoARed" className="material-icon"></span>
                          </figure>
                        </div>
                      </div>

                    </div>

                  </div>
                  
              </section>              

            </div>              

          </div>

          <div id="divBotonChat" className="horizontal center ">
            <button id="divIconoChat" className="button tertiary full-width" onClick={() => abrirChat()}>
            <img src={avatarHelias} alt="Chat" width="36"/><span>¿Alguna consulta?</span>
            </button>
          </div>

        </div>

      <WidgetDetail 
        fromDatetime={objHorarioSol.Sunrise} 
        toDatetime={objHorarioSol.Sunset} 
        graphsData={graphsData}         
        objDayForecasting={objDayForecasting} 
        municipalityId={municipalityId}
        weekForecastUpdateTimestamp={weekForecastUpdateTimestamp}
        setObjWeekForecastUpdateTimestamp={setObjWeekForecastUpdateTimestamp}        
        setObjDevicesUpdateTimestamp={setObjDevicesUpdateTimestamp}
        seleccionarOpcionMenu={params.seleccionarOpcionMenu}/>

      <DevicesOperationMenu objListadoDispositivos={objListadoDispositivos} update={devicesUpdateTimestamp}/>

    </main>
  )
}

export default Dashboard